<script>
import VueGallery from 'vue-gallery';
import Button from '@/components/Button.vue';

export default {
  name: 'ProjectDescription',
  props: {
    name: String,
    description: String,
    images: Array,
    projectLink: String,
    mobile: Boolean,
    imageWidth: {
      type: Number,
      default: 150,
    },
  },
  data() {
    return {
      index: null,
    };
  },
  components: {
    Button,
    VueGallery,
  },
};
</script>

<template>
  <div class="project">
    <VueGallery :images="images" :index="index" @close="index = null" />
    <div class="image-container" v-if="!mobile">
      <div v-for="(image, imageIndex) in images" :key="image">
        <img
          :src="image"
          class="image"
          :style="{maxWidth: imageWidth + 'px'}"
          @click="index = imageIndex"
        />
      </div>
    </div>
    <div class="content">
      <div class="name">
        {{name}}
      </div>
      <div class="illustrations">
        <Button @click="index = 0" glitch-hover fluid v-if="mobile">
          <template #icon>
            <i class="fas fa-images"/>
          </template>
          Иллюстрации
        </Button>
      </div>
      <div class="description">{{description}}</div>
      <Button glitch-hover :href="projectLink" target="_blank">
        Перейти к приложению
      </Button>
    </div>
  </div>
</template>

<style scoped>
  .project {
    display: flex;
    flex-direction: column;
  }

  .name {
    font-size: var(--font-size-l);
    font-weight: bold;
    color: var(--main-bright);
    margin-bottom: 24px;
  }

  .illustrations {
    margin-bottom: 20px;
  }

  .content {
    padding: 20px 32px 20px 0;
    color: var(--main-bright);
  }

  .image {
    margin-right: 8px;
  }

  .image-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .description {
    font-size: var(--font-size-s);
    white-space: pre-wrap;
    margin-bottom: 40px;
  }
</style>
